import { useEffect, useState } from "react";
import CheckoutHeader from "../../../components/checkout/CheckoutHeader";
import Box from "@mui/system/Box";
import styles from "./style.module.css";
import { Button, Grid, Typography } from "@mui/material";
import LeftSidebar from "../../../components/sidebars/LeftSidebar";
import ProductImage from "../../../images/product.png";
import { UserCommonStyles } from "../../../../src/styles/CommonStyles";
import { useHistory } from "react-router-dom";
import { RoutingLinks, Type } from "../../../utils/constants";
import { useTranslation } from "react-i18next";
import MinusIcon from "../../../images/minus.png";
import PlusIcon from "../../../images/plus.png";
import SocialIconSection from "../../../components/sidebars/SocialIconSection";
import { useDispatch } from "react-redux";
import { HomeStyles } from "../../../styles/HomeStyles";
import { productCountHandler } from "../../../components/header/Header";
import { getAllShoppingCarTDataById } from "../../../redux/action-creators/productAction";
import { capitalize } from "../../../utils/helper";
import ClipLoader from "react-spinners/ClipLoader";

const CheckoutStep1 = () => {
  const commonStyle = UserCommonStyles();
  const styleClasses = HomeStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t: translation } = useTranslation();

  const [shoppingData, setShoppingData] = useState<any>(
    JSON.parse(localStorage.getItem(Type?.shoppingBag) || "[]") || []
  );
  const [loader, setloader] = useState<boolean>(false);
  const [deliveryRate, setDeliveryRate] = useState<number>(3.99);
  const [subtotal, setSubtotal] = useState<number>(0);
  const [taxAmount, setTaxAmount] = useState<number>(0);
  const [checkoutLoader, setCheckoutLoader] = useState<boolean>(false);
  const [checkQuantityError, setCheckQuantityError] = useState<any>([]);

  const getShoppingProduct = () => {
    setloader(true);
    setShoppingData(JSON.parse(localStorage.getItem(Type?.shoppingBag)));
    subTotalHandler();
    setloader(false);
  };

  /**
   * get product details for check quantity
   */
  const getProductDetailsForCheckQuantity = async () => {
    const temp = [];
    if (shoppingData.length) {
      shoppingData.forEach(async (product: any) => {
        temp.push(Number(product?.product_id));
      });
      const data = { all_products: temp };
      const response: any = await dispatch(getAllShoppingCarTDataById(data));
      if (response && response.length) {
        // setCheckQuantity(response);
        return response;
      }
    }
  };

  useEffect(() => {
    // getShoppingProduct();
    subTotalHandler();
  }, [shoppingData]);

  const productRemoveHandler = (id: number) => {
    const result = shoppingData.filter((ele: any) => ele?.product_id !== id);
    localStorage.setItem(Type?.shoppingBag, JSON.stringify(result));
    setShoppingData(JSON.parse(localStorage.getItem(Type?.shoppingBag)));
    subTotalHandler();
    productCountHandler(result?.length);
    return history.push(RoutingLinks.checkout_step1);
  };

  const decrementHandler = (id: number, quantity: number) => {
    if (quantity <= 1) {
      const result = shoppingData.filter((ele: any) => ele?.product_id !== id);
      localStorage.setItem(Type?.shoppingBag, JSON.stringify(result));
      setShoppingData(JSON.parse(localStorage.getItem(Type?.shoppingBag)));
      subTotalHandler();
      productCountHandler(result?.length);
      return history.push(RoutingLinks.checkout_step1);
    } else {
      const newArr: any = [...shoppingData];
      const findExistingProductIndex = newArr.findIndex(
        (ele: any) => ele?.product_id === id
      );
      if (findExistingProductIndex !== -1) {
        if (newArr[findExistingProductIndex]) {
          newArr[findExistingProductIndex].order_quantity -= 1;
          localStorage.setItem(Type?.shoppingBag, JSON.stringify(newArr));
          setShoppingData(JSON.parse(localStorage.getItem(Type?.shoppingBag)));
          subTotalHandler();
        }
      }
    }
  };

  const incrementHandler = async (id: any, quantity: number) => {
    quantity += 1;
    // const response = await getProductDetailsForCheckQuantity();
    // let obj = { notAvailableQuantity: false, name: "" };
    // if (response.length) {
    //   response.forEach((ele: any) => {
    //     if (ele?.id === id && ele?.product_quantity < quantity) {
    //       obj.notAvailableQuantity = true;
    //       obj.name = ele?.name;
    //     }
    //   });
    // if (!obj?.notAvailableQuantity) {
    //   toast.info(
    //     `The additional quantity of this product (${obj.name}) is not currently available.`
    //   );
    // } else {
    const newArr: any = [...shoppingData];
    const findExistingProductIndex = newArr.findIndex(
      (ele: any) => ele.product_id === id
    );
    if (findExistingProductIndex !== -1) {
      if (newArr[findExistingProductIndex]) {
        newArr[findExistingProductIndex].order_quantity = quantity;
      }
    }
    localStorage.setItem(Type?.shoppingBag, JSON.stringify(newArr));
    setShoppingData(JSON.parse(localStorage.getItem(Type?.shoppingBag)));
    // setShoppingData(newArr)
    subTotalHandler();
    // }
    // }
  };

  const subTotalHandler = () => {
    const getData = JSON.parse(localStorage.getItem(Type?.shoppingBag));
    let total = 0;
    if (getData) {
      getData.forEach((ele: any) => {
        total += ele?.price * ele?.order_quantity;
      });
      setSubtotal(total);
      setTaxAmount((total / 100) * 7);
    }
  };

  const checkQuantityHandler = (arr: any) => {
    const temp = [];
    for (let i = 0; i < arr?.length; i++) {
      if (
        arr[i]?.id === shoppingData[i]?.product_id &&
        arr[i]?.product_quantity < shoppingData[i]?.order_quantity
      ) {
        temp.push(arr[i]);
      }
    }
    return temp;
  };

  const checkoutHandler = async () => {
    setCheckoutLoader(true);
    const response: any = await getProductDetailsForCheckQuantity();
    if (response?.length) {
      const checkedData: any = checkQuantityHandler(response);
      if (checkedData?.length) {
        setCheckQuantityError(checkedData);
        setCheckoutLoader(false);
        return window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
      } else {
        setCheckQuantityError([]);
        const oldArray = [...shoppingData];
        const newArray = oldArray.map(({ product_image, ...test }) => test);
        const data = {
          product: newArray,
          subtotal: subtotal,
          deliveryRate: deliveryRate ? deliveryRate : 3.99,
          tax: taxAmount,
        };
        localStorage.setItem(Type?.shoppingCartCheckout, JSON.stringify(data));
        history.push(RoutingLinks.checkout_step2_shipping);
        setCheckoutLoader(false);
      }
    }
  };

  return (
    <Box>
      <Box className={styles.windowColor}>
        <Grid container>
          <Grid item md={3}>
            <LeftSidebar />
            {/* <SocialIconSection /> */}
          </Grid>

          <Grid item md={9}>
            <Typography mt={5} ml={2} mb={3} className={styles.heading}>
              Shopping Cart
            </Typography>
            <Box className={styles.subContainer}>
              <CheckoutHeader step2={false} step3={false} />
              {shoppingData.length > 0 ? (
                shoppingData.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      <Box className={styles.productContainer}>
                        <div className={styles.my_bag_product}>
                          <img
                            src={
                              item?.product_image
                                ? item?.product_image
                                : ProductImage
                            }
                            className={styles.image}
                          />
                          <div className={styles.name_and_option}>
                            <Typography className={styles.name}>
                              {item?.name ? item?.name : ""}
                            </Typography>
                            <Box className={styleClasses.removeBtn}>
                              <Button
                                variant="text"
                                onClick={() =>
                                  productRemoveHandler(item?.product_id)
                                }
                              >
                                {"REMOVE"}
                              </Button>
                            </Box>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div className={styles.counterContainer}>
                            <Button
                              size="small"
                              onClick={() =>
                                decrementHandler(
                                  item?.product_id,
                                  item?.order_quantity
                                )
                              }
                            >
                              <img
                                src={MinusIcon}
                                alt=""
                                style={{
                                  width: "15px",
                                  height: "3px",
                                  cursor: "pointer",
                                }}
                              />
                            </Button>
                            <p className={styles.count_text}>
                              {item?.order_quantity
                                ? item?.order_quantity
                                : "0"}
                            </p>
                            <Button
                              size="small"
                              onClick={() =>
                                incrementHandler(
                                  item?.product_id,
                                  item?.order_quantity
                                )
                              }
                            >
                              <img
                                src={PlusIcon}
                                alt="Increment"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  cursor: "pointer",
                                }}
                              />
                            </Button>
                          </div>
                          <p
                            style={{
                              fontFamily: "Roboto",
                              fontSize: "18px",
                              fontWeight: "400",
                              margin: "0px !important",
                              padding: "0px !important",
                            }}
                          >
                            {item?.price && item?.order_quantity
                              ? `$${(
                                  item?.price * item?.order_quantity
                                ).toFixed(2)}`
                              : "$0.00"}
                          </p>
                        </div>
                      </Box>
                      {checkQuantityError?.length > 0
                        ? checkQuantityError.map(
                            (error: any, index: number) => {
                              if (error?.id === item?.product_id) {
                                return (
                                  <div
                                    style={{
                                      width: "82%",
                                      height: "auto",
                                      marginRight: "auto",
                                      marginLeft: "auto",
                                      marginTop: 15,
                                    }}
                                  >
                                    <span className={commonStyle.errorMsg}>
                                      {`${
                                        item?.name ? capitalize(item?.name) : ""
                                      } quantity is currently ${
                                        error?.product_quantity
                                      } available.${
                                        error?.product_quantity === 0
                                          ? ""
                                          : " Please decrease your quantity."
                                      }`}
                                    </span>
                                  </div>
                                );
                              }
                            }
                          )
                        : ""}

                      <div
                        style={{
                          width: "82%",
                          height: 1,
                          backgroundColor: "#BDBDBD",
                          marginRight: "auto",
                          marginLeft: "auto",
                          marginTop: 40,
                          marginBottom: 40,
                        }}
                      ></div>
                    </div>
                  );
                })
              ) : loader ? (
                <div style={{ paddingLeft: "20px" }}>{"Loading..."}</div>
              ) : (
                <div style={{ paddingLeft: "20px" }}>{"No orders in cart"}</div>
              )}
              {shoppingData.length > 0 ? (
                <Box
                  style={{
                    paddingRight: "100px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <p className={styles.summeryHeading}>Order summary</p>
                    <div>
                      <div className={styles.summary_Detail_Container}>
                        <p className={styles.title}>Subtotal</p>
                        <p className={styles.value}>
                          {subtotal ? `$${subtotal.toFixed(2)}` : "$0.00"}
                        </p>
                      </div>
                      <div className={styles.summary_Detail_Container}>
                        <p className={styles.title}>Tax 7%</p>
                        <p className={styles.value}>
                          {taxAmount ? `$${taxAmount.toFixed(2)}` : "$0.00"}
                        </p>
                      </div>
                      <div className={styles.summary_Detail_Container}>
                        <p className={styles.title}>Delivery</p>
                        <p className={styles.value}>{`$${
                          deliveryRate ? deliveryRate : "3.99"
                        }`}</p>
                      </div>
                    </div>
                    <div className={styles.borderBottom}></div>
                    <div className={styles.summary_Detail_Container}>
                      <p className={styles.total}>Total</p>
                      <p className={styles.price}>
                        {subtotal && deliveryRate && taxAmount
                          ? `$${(subtotal + deliveryRate + taxAmount).toFixed(
                              2
                            )}`
                          : "$0.00"}
                      </p>
                    </div>
                    <Box className={` ${commonStyle.blueBtn} `}>
                      <Button
                        fullWidth
                        disabled={checkoutLoader}
                        style={{
                          fontFamily: "Roboto",
                          fontWeight: "400",
                          fontSize: "20px",
                          alignItems: "center",
                          color: "#fff",
                        }}
                        onClick={checkoutHandler}
                      >
                        Check out{checkoutLoader ? <ClipLoader /> : ""}
                      </Button>
                    </Box>
                  </div>
                </Box>
              ) : null}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CheckoutStep1;
